import React from 'react'
import ContentArea from '../../components/ContentArea'

import Player from '../../components/Player'
// import { audioFile } from '../audioUtil'

import GuidedSleep from '../../assets/audio/Guided_Imagery_for_Sleep_Dr._Tobia.m4a'

const InsomniaPage = () => {
    return (

<ContentArea transparent shadowless fullsize>
      <Player audioSrc={GuidedSleep} text={`Guided Sleep`} />
    </ContentArea>
    )
}

export default InsomniaPage





